import '@greatmindsorg/icominds-lib/dist/css/style.css';
import { AppThemeProvider } from '@insync-students-themes/utilities/theme.provider';
import { ThemesContextProvider } from '@insync-students-stores/themeContext';
import { FiltersContextProvider } from '@insync-students-stores/filtersContext';
import { UserProvider } from '@insync-students-stores/userContext';
import { EventsProvider } from '@insync-students-stores/eventsContext';
import { UploadProvider } from '@insync-students-stores/uploadContext';
import { ServicesProvider } from '@insync-students-stores/servicesContext';
import { ResourceViewerProvider } from '@insync-students-components/ResourceViewer/stores/resourceViewerContext';
import { CustomToastProvider } from '@insync-students-lib/hooks/useCustomToast';
import { ReactNode } from 'react';
interface IProps {
  children: ReactNode;
  schoolYear?: string;
}
export const AppProviders: React.FC<IProps> = ({
  children,
  schoolYear
}) => <ServicesProvider schoolYear={schoolYear}>
    <EventsProvider>
      <UserProvider schoolYear={schoolYear}>
        <FiltersContextProvider>
          <ThemesContextProvider>
            <CustomToastProvider>
              <UploadProvider>
                <ResourceViewerProvider>
                  <AppThemeProvider>{children}</AppThemeProvider>
                </ResourceViewerProvider>
              </UploadProvider>
            </CustomToastProvider>
          </ThemesContextProvider>
        </FiltersContextProvider>
      </UserProvider>
    </EventsProvider>
  </ServicesProvider>;